import styled from 'styled-components';
import { H3, Small } from 'components/Typography';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div``;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem 2rem;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 1.5rem;
  margin-bottom: 1.5rem;
`;

export const Text = styled(Small)`
  color: ${({ theme }) => theme.colors.navyGreen};
`;

// TODO: TFR-45:Title make unique name or do not export
export const Title = styled(H3)`
  margin-bottom: 0.5rem;
`;
